import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, ColumnApi } from 'ag-grid-community';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import bb from "billboard.js";
import moment from 'moment';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AppServiceService } from './services/product.service';
import debounce from  'lodash/debounce';

@Component({
    selector: 'product-template',
    template: require('./productTemplate.html'),
    styles: [``]
})
export class ProductTemplateComponent implements OnInit {
    @Input('prodList1') prodList1: any;
    @Input('DisableClose') DisableClose: any = 0;
    @Input('filterType') filterType: any;
    @Input('SerachValue') SerachValue: any;
    @Input('LastSelectedId') LastSelectedId: any;
    @Input('custId') custId: any = 0;
    @Input('custcode') custcode: any = '';
    @Input("dValue") dvalue: any;
    @Input("Transaction_page") Transaction_page: any = 0;
    @Output() SelectedProduct = new EventEmitter();
    @ViewChild('ProductNotespopup') ProductNotespopup: ElementRef;
    @ViewChild('SalesHistorypopup') SalesHistorypopup: ElementRef;
    @ViewChild('PurchaseHistorypopup') PurchaseHistorypopup: ElementRef;
    @ViewChild('MonthWiseSalespopup') MonthWiseSalespopup: ElementRef;
    @ViewChild('BatchHoldDetailspopup') BatchHoldDetailspopup: ElementRef;
    @ViewChild('SalesExpHistorypopup') SalesExpHistorypopup: ElementRef;
    @ViewChild('AllBatchpopup') AllBatchpopup: ElementRef;
    @ViewChild('stockmodalpopup123') stockmodalpopup123: ElementRef;
    @ViewChild('pendingsalespopup1') pendingsalespopup1: ElementRef;

    LastSearchText: any;
    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, AppServiceService]
    dateFormat: any;
    bsConfig: any;

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }

    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public _AppServiceService: AppServiceService) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;

        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.dateFormat.dateInputFormat, containerClass: this.dateFormat.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.dateFormat.dateInputFormat;
    }

    gridApiPrd: any;
    gridColumnApiPrd: any;
    selectedProductInfo: any;
    prodList: any;
    paginationConf: any;
    d: any;
    productListDef: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    ProductStock: any;
    ProductStockBrnch: any;
    TblProductStock: any;
    TblProductStockBranch: any;
    modalReference: NgbModalRef;
    //filterType:any;
    SortedProdList: any;
    GRNBAllowsalescheme: any = 0;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        // backdrop: `rgba(30, 30, 37, 0.4)`
    });

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chknum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    public hotkeyList: Hotkey[];
    public orderSearch: any;
    public overlayLoadingTemplate: any;
    public SelectedRowIndex = 0;
    public selectedProduct2: any;
    stockmodalpopupRef: NgbModalRef;

    ngOnInit(): void {
        $('.template-hidden-values #HiddenProdEnterEventTriggered').val(0);
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.ProductStock = '';
        this.ProductStockBrnch = '';
        this.TblProductStock = [];
        this.TblProductStockBranch = [];
        this.SortedProdList = [];
        this.initHotkeys();
        this.orderSearch = {};
        this.orderSearch.filtertype = 'C';
        this.orderSearch.From_Date = new Date();
        this.orderSearch.To_Date = new Date();
        this.prodList = [];
        this.defaultColDef = {
            resizable: true,
            sortable: true,
        };
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";
        this.productListDef = [
            // { headerName: 'ID', field: 'Product_ID', width: 70, },
            { headerName: 'Code', field: 'Product_Code', width: 90, },
            { headerName: 'ED Code', field: 'AltCode', width: 90, },
            { headerName: 'Name', field: 'Product_Desc', width: 450, },
            { headerName: 'Name', field: 'SearchProduct', hide: true },
            { headerName: 'Pack', field: 'Packsize', width: 100, },
            { headerName: 'Case Qty', field: 'CaseQty', width: 60, cellStyle: { 'textAlign': "right" }},
            { headerName: 'Box Packing', field: 'Box_Packing', width: 60, cellStyle: { 'textAlign': "right" } },            //{ headerName: 'MRP', field: 'MRP', width: 83, cellStyle: {'text-align': 'right'} },
            //{ headerName: 'Rate', field: 'Rate', width: 87, },
            //{ headerName: 'PTR', field: 'PTR', width: 75, cellStyle: {'text-align': 'right'} },
            { headerName: 'Unit', field: 'Base_Unit', width: 60 },
            { headerName: 'Per Box', field: 'perbox', width: 40 },
            { headerName: 'Manufacturer', field: 'Manufacturer_Name', width: 100, enableCellChangeFlash: true },
            { headerName: 'Division', field: 'Division_Name', width: 100, enableCellChangeFlash: true },
            { headerName: 'SearchFilterValue', field: 'SearchFilterValue', width: 100, hide: true },
            //{ headerName: 'Alt Code', field: 'altCode', width: 93, enableCellChangeFlash: true },
        ];
        this.prodList = this.prodList1;
        this.selectedProduct2 = {};
        this.GRNBAllowsalescheme = 0;

        if ("SystemConfigDetails" in localStorage) {
            var data = JSON.parse(localStorage.getItem('SystemConfigDetails'))

            var GRNBAllowsalescheme = data.filter(function (item) {
                return item.Config_Name === 'Allow Sales Scheme % in GRN'
            });
            if (GRNBAllowsalescheme.length > 0) {
                this.GRNBAllowsalescheme =  this.f_chknum(GRNBAllowsalescheme[0].Config_Value);
            }
        }
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    initHotkeys() {
        this.hotkeyList = [];
        const altd = new Hotkey('alt+d', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Product_Code"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altd);
        this.hotkeysService.add(altd);

        const alte = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Molecule_Desc"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alte);
        this.hotkeysService.add(alte);

        const altn = new Hotkey('alt+n', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Product_Desc"]').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altn);
        this.hotkeysService.add(altn);

        const altu = new Hotkey('alt+u', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Manufacturer_Name"]').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altu);
        this.hotkeysService.add(altu);

        const altl = new Hotkey('alt+l', (event: KeyboardEvent): boolean => {
            this.filterProducts(event, "AllItems");
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altl);
        this.hotkeysService.add(altl);

        const alts = new Hotkey('alt+s', (event: KeyboardEvent): boolean => {
            this.filterProducts(event, "Substitute");
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alts);
        this.hotkeysService.add(alts)

        const alti = new Hotkey('alt+i', (event: KeyboardEvent): boolean => {
            this.filterProducts(event, 'NewItems');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alti);
        this.hotkeysService.add(alti)

        const altp = new Hotkey('alt+p', (event: KeyboardEvent): boolean => {
            this.filterProducts(event, 'Promotional');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altp);
        this.hotkeysService.add(altp)

        const altt = new Hotkey('alt+t', (event: KeyboardEvent): boolean => {
            this.OpenProductNotesPopup(this.ProductNotespopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altt);
        this.hotkeysService.add(altt);

        const altb = new Hotkey('alt+b', (event: KeyboardEvent): boolean => {
            this.OpenBatchHoldDetailspopup(this.BatchHoldDetailspopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altb);
        this.hotkeysService.add(altb);

        const alth = new Hotkey('alt+h', (event: KeyboardEvent): boolean => {
            this.OpenSalesHistoryPopup(this.SalesHistorypopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alth);
        this.hotkeysService.add(alth);

        const altr = new Hotkey('alt+r', (event: KeyboardEvent): boolean => {
            this.OpenPurchaseHistorypopup(this.PurchaseHistorypopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altr);
        this.hotkeysService.add(altr);

        const altm = new Hotkey('alt+m', (event: KeyboardEvent): boolean => {
            this.OpenMonthWiseSalespopup(this.MonthWiseSalespopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altm);
        this.hotkeysService.add(altm);

        const altx = new Hotkey('alt+x', (event: KeyboardEvent): boolean => {
            this.OpenSalesExpHistorypopup(this.SalesExpHistorypopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altx);
        this.hotkeysService.add(altx);

        const alta = new Hotkey('alt+a', (event: KeyboardEvent): boolean => {
            this.OpenAllBatchpopup(this.AllBatchpopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alta);
        this.hotkeysService.add(alta);

        const altc = new Hotkey('home', (event: KeyboardEvent): boolean => {
            this.clearAllFilter();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altc);
        this.hotkeysService.add(altc);

        const altz = new Hotkey('alt+z', (event: KeyboardEvent): boolean => {
            this.GetOtherBranchData(this.stockmodalpopup123);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altz);
        this.hotkeysService.add(altz);

        const shiftq = new Hotkey('shift+q', (event: KeyboardEvent): boolean => {
            this.processPendingQty1();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(shiftq);
        this.hotkeysService.add(shiftq);

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {

            var textbox: any;
            textbox = document.querySelector('#prodfilter-text-box');
            if (textbox) {
                const bound = textbox.getBoundingClientRect();
                if (bound && bound.top) {
                    $('#prodfilter-text-box').focus();
                }
            }
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);

        const alto = new Hotkey('alt+o', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="AltCode"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alto);
        this.hotkeysService.add(alto);
    }

    ngOnDestroy() {
        this.hotkeysService.remove(this.hotkeyList);
    }

    onGridReadyPrd(params) {
        var parent = this;
        $("#prodfilter-text-box").keypress(function (event) {
            if (event.keyCode == 13) {
                parent.custSelectionMain(parent);
            }
        });
        if (!this.filterType) {
            this.filterType = "SearchProduct";
        }
        $(".radio-label").change(function () {
            var select = $(this).val();
            $("input#prodfilter-text-box").val("");
            if (select == 'Product_Code') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Code (CTRL+F)").blur();
            } else if (select == 'SearchProduct') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Name (CTRL+F)").blur();
            } else if (select == 'Manufacturer_Name') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Manufacturer (CTRL+F)").blur();
            } else if (select == 'Molecule_Desc') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Salt/Molecule (CTRL+F)").blur();
            } else if (select == 'AltCode') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By ED Code (CTRL+F)").blur();
            }
            parent.SelectedRowIndex = 0;
            parent.searchValue = "";
            parent.quickSearch("", 0);
            setTimeout(() => {
                $('#prodfilter-text-box').focus().select();
            }, 200);
        });

        $(document).ready(function () {
            if (parent.filterType == 'Product_Code') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Code (CTRL+F)").blur();
            } else if (parent.filterType == 'SearchProduct') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Name (CTRL+F)").blur();
            } else if (parent.filterType == 'Manufacturer_Name') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Manufacturer (CTRL+F)").blur();
            } else if (parent.filterType == 'Molecule_Desc') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Salt/Molecule (CTRL+F)").blur();
            } else if (parent.filterType == 'AltCode') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By ED Code (CTRL+F)").blur();
            }
            setTimeout(() => {
                $('#prodfilter-text-box').focus().select();
            }, 200);
        });

        this.gridApiPrd = params.api;
        setTimeout(() => {
            this.gridColumnApiPrd = params.columnApi;
            //this.gridApiPrd.sizeColumnsToFit();
            this.SelectedRowIndex = this.f_ChkNum(this._AppServiceService.LastSelectedProductIndex);
            let ProductSearch = this.f_chkString(this._AppServiceService.LastProductSearchValue);
            this._AppServiceService.setLastProductSearchValue("");
            $('#prodfilter-text-box').focus().select();
            if (this.SerachValue) {
                this.SelectedRowIndex = 0;
                this.searchValue = this.SerachValue;
                this.quickSearch("", 1);
            } else {
                this.searchValue = ProductSearch;
                this.quickSearch("", 1);
            }
        }, 100);
    }

    gridEventDown(event) {
        if (event.keyCode == 13) {
            this.custSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#prodfilter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90 && !event.altKey && !event.shiftKey) {
            $('#prodfilter-text-box').focus();
            this.searchValue = event.key;
            this.quickSearch('', 0);
        }
    }

    private custSelectionMain(self: this) {
        try {
            var RowCount = this.gridApiPrd.getModel().getRowCount();
            if (RowCount == 0) {
                return false;
            }
            let selectedRows = self.gridApiPrd.getSelectedRows();
            let cust = selectedRows[0];

            if (!(cust && this.f_chknum(cust.Product_ID) > 0)) {
                return false;
            }
            if(this.f_chknum(cust.HSN_ID) == 0 && this.f_ChkNum(this.Transaction_page) == 0){
                this.toastWarningMsg('Product found blank HSN, please add HSN in the product master');
                return false;
            }
            var EnterEventTriggerd = this.f_chknum($('.template-hidden-values #HiddenProdEnterEventTriggered').val());
            if (this.f_chknum(this.DisableClose) == 1 || EnterEventTriggerd) {
                return false;
            } 
            $('.template-hidden-values #HiddenProdEnterEventTriggered').val(1);
            let searchValue = this.f_chkString(this.searchValue);
            this._AppServiceService.setLastProductSearchValue(searchValue);
            let selectedProduct = this.gridApiPrd.getSelectedNodes();
            if (selectedProduct.length > 0) {
                this._AppServiceService.setLastSelectedProductIndex(selectedProduct[0].rowIndex);
            }
            cust.filterType = this.filterType;
            if (this.httpCalling && this.httpCalling.isStopped) {
                cust.WareHouseData = this.TblProductStock;
                this.SelectedProduct.emit(cust);
            } else {
                // this.httpCalling ? this.httpCalling.unsubscribe() : null;
                let dataWare = { "Product_ID": cust.Product_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID };
                this.http.get(`/api/${this.unitInfo.Company_Code}/products/GET_PRODUCT_STOCK`, { params: dataWare })
                    .subscribe(result => {
                        this.TblProductStock = result;
                        cust.WareHouseData = this.TblProductStock;
                        this.SelectedProduct.emit(cust);
                    });
            }
            // $('.template-hidden-values #HiddenProdEnterEventTriggered').val(1);
        } catch (ex) {
            console.error(ex);
            $('.template-hidden-values #HiddenProdEnterEventTriggered').val(0);
        }
    }
    invoiceInfo: any;
    productFilterd: any;
    httpCalling: any;
    SaltMolecule: any;
    Division_Name: any;
    Category_Name: any;
    HSN_igst: any;
    Special_Remark: any;
    Cess_Percent: any;

    prodSelected(event) {
        this.selectedProductInfo = {};
        this.SetProductDetails(this.selectedProductInfo);
        this.AfterProdSelection(event);
        this.ProductBatchWiseSchemeInfo.ProductBatchScheme = '';
        this.ProductBatchWiseSchemeInfo.ProductBatchSchemePer = '';
        this.BatchwiseschemeFreeQty = 0;
        this.BatchwiseschemeFreeQty1 = 0;
        this.BatchwiseschemeFreeQty2 = 0;
        this.GetProductSchemeInfo();
    }
    
    AfterProdSelection = debounce((event) => {
        let selectedRowCust = this.gridApiPrd.getSelectedRows();
        if (selectedRowCust.length == 0) {
            return false;
        }
        this.selectedProductInfo = selectedRowCust[0];
        this.SetProductDetails(this.selectedProductInfo);
        if(this.unitInfo.UnitCount > 1){
            this.OtherBranchStock(this.selectedProductInfo.Product_ID);
        }
        /* if (this.f_ChkNum(this.selectedProductInfo.batchPresent) == 1) { */
            let dataWare = {
                "Product_ID": this.selectedProductInfo.Product_ID,
                "Unit_ID": this.unitInfo.Unit_ID,
                "Company_ID": this.unitInfo.Company_ID
            };
            this.httpCalling = this.http.get(`/api/${this.unitInfo.Company_Code}/products/GET_PRODUCT_STOCK`, { params: dataWare })
                .subscribe(result => {
                    this.TblProductStock = result;
                    this.ProductStock = this.f_ChkNum(this.TblProductStock.reduce(function (acc, sum) {
                        return acc + parseInt(sum.available);
                    }, 0));
                });
        /* } else {
            this.ProductStock = 0;
        } */
    }, 200);
    

    SetProductDetails(selectedProductInfo) {
        selectedProductInfo = selectedProductInfo ? selectedProductInfo : {};
        this.SaltMolecule = selectedProductInfo.Molecule_Desc;
        this.Division_Name = selectedProductInfo.Division_Name;
        this.Category_Name = selectedProductInfo.Category_Name;
        this.HSN_igst = selectedProductInfo.HSN_igst;
        this.ProductStock = '';
        this.ProductStockBrnch = '';
        this.TblProductStock = [];
        this.Special_Remark = selectedProductInfo.Special_Remark;
        this.Cess_Percent = selectedProductInfo.Cess_Percent;
    }

    onProdSelectionChanged(event) {
        this.custSelectionMain(this);
    }
    /* quickSearch(event, id) {
        if (id == 'product') {
            this.gridApiPrd.setQuickFilter(this.searchValue);
            this.gridApiPrd.onFilterChanged();
            this.gridApiPrd.getModel().getRow(0).setSelected(true);
            this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            if (event.which == 13 || event.which == 40) {
                this.gridApiPrd.setFocusedCell(0, "Product_Code");
            }
        }
    } */

    quickSearch(event, OnLoad = 0) {
        if (event.which == 37 || event.which == 38 || event.which == 39 || event.which == 16 || event.which == 17 || event.which == 70) {
            return false;
        }
        if(event.which == 27) {
            this.d();
            return false;
        }
        if (event.which == 13 || event.which == 40) {
            this.afterSearchSetGridEvent(event, this.SelectedRowIndex);
            return false;
        }
        let search = this.f_chkString(this.searchValue).toLocaleUpperCase();
        if(search === this.LastSearchText) {
            this.afterSearchSetGridEvent(event, this.SelectedRowIndex);
            return false;
        }
        this.LastSearchText = search;
        let rowData = [];
        let sortModel = [];
        if (search.length > 0) {
            let search1 = search.split(' ');
            search1 = search1.filter(item => item.length > 0);
            if (search1.length > 1) {
                rowData = this.prodList.filter(item => {
                    return search1.every((filterWord) => item[this.filterType].toLocaleUpperCase().indexOf(filterWord) >= 0);
                });
            } else {
                rowData = this.prodList.filter(item => {

                    if(item[this.filterType]){
                        return item[this.filterType].toLocaleUpperCase().indexOf(search1[0]) >= 0;
                    }

                    //return item[this.filterType].toLocaleUpperCase().indexOf(search1[0]) >= 0;
                });
            }
            rowData.map(item => {
                item.SearchFilterValue = 3;
                if (item[this.filterType].toLocaleUpperCase().includes(search1[0])) {
                    item.SearchFilterValue = 2;
                }
                if (item[this.filterType].toLocaleUpperCase().startsWith(search1[0])) {
                    item.SearchFilterValue = 1;
                }
            });
            this.gridApiPrd.setSortModel([]);
            sortModel = [
                { colId: 'SearchFilterValue', sort: 'asc' },
                { colId: this.filterType, sort: 'asc' }
            ];
        } else {
            rowData = this.prodList;
            sortModel = [
                { colId: this.filterType, sort: 'asc' }
            ];
        }
        this.gridApiPrd.setSortModel([]);
        this.gridApiPrd.setRowData(rowData);
        this.gridApiPrd.setSortModel(sortModel);
        if (!(event.which == 13 || event.which == 40) && OnLoad == 0) {
            this.SelectedRowIndex = 0;
        }
        this.afterSearchSetGridEvent(event, this.SelectedRowIndex);
    };

    afterSearchSetGridEvent(event, Index) {
        let RowCount = this.gridApiPrd.getModel().getRowCount();
        if (RowCount >= Index && RowCount > 0) {
            this.gridApiPrd.ensureIndexVisible(Index);
            this.gridApiPrd.getModel().getRow(Index).setSelected(true);
        }
        if ((event.which == 13 || event.which == 40) && RowCount >= Index && RowCount > 0) {
            this.gridApiPrd.setFocusedCell(Index, "Product_Code");
        }
    }

    quickSearch1(event, OnLoad = 0) {
        if (event.which == 37 || event.which == 38 || event.which == 39 || event.which == 16 || event.which == 17 || event.which == 70) {
            return false;
        }
        if (event.which == 40) {
            // if (this.gridApiPrd.getInfiniteRowCount() < this.SelectedRowIndex) {
            //     this.gridApiPrd.setInfiniteRowCount(this.SelectedRowIndex, false);
            // }
            this.gridApiPrd.ensureIndexVisible(this.SelectedRowIndex);
            this.gridApiPrd.getModel().getRow(this.SelectedRowIndex).setSelected(true);
            this.gridApiPrd.setFocusedCell(this.SelectedRowIndex, "Product_Code");
            return false;
        } else {
            this.SelectedRowIndex = 0;
        }
        var IsSearchContain = "";

        var sportsFilterComponent = this.gridApiPrd.getFilterInstance(this.filterType);
        if (this.searchValue) {
            // let search:any;
            // if(this.filterType == 'SearchProduct'){
            let search = (this.searchValue ? this.searchValue.toString() : "").trim();
            let search1 = search.split(" ");
            if (search1.length > 1) {
                sportsFilterComponent.setModel({
                    condition2: {
                        type: "contains",
                        filter: search1[1]
                    },
                    condition1: {
                        type: "startsWith",
                        filter: search1[0]
                    },
                    condition3: {
                        type: "startsWith",
                        filter: search1[1]
                    },
                    operator: "AND"
                });
            }
            else {
                var index = search.indexOf("%");
                if (index >= 0) {
                    search = search.replace(/%/g, "");
                    IsSearchContain = search;
                }
                sportsFilterComponent.setModel({
                    type: (index >= 0) ? "contains" : "startsWith",
                    filter: search
                });
                if (index < 0) {
                    this.gridApiPrd.onFilterChanged();
                    if (this.gridApiPrd.getModel().getRowCount() == 0) {
                        sportsFilterComponent.setModel({
                            type: "contains",
                            filter: search
                        });
                    }
                }
            }
            // } else {
            //     search = (this.searchValue? this.searchValue.toString(): "").trim().split(" ");
            //     sportsFilterComponent.setModel({
            //         condition2: {
            //             type: "contains",
            //             filter: search[1]
            //         },
            //         condition1: {
            //             type: "startsWith",
            //             filter: search[0]
            //         },
            //         condition3: {
            //             type: "startsWith",
            //             filter: search[1]
            //         },
            //         operator: "AND"
            //     });
            // }
        } else {
            this.gridApiPrd.setFilterModel(null);
        }
        this.gridApiPrd.onFilterChanged();
        var TotalRowCount = this.gridApiPrd.getModel().getRowCount();
        if (TotalRowCount > 0 && OnLoad == 0) {
            if ((IsSearchContain ? IsSearchContain : "").length > 0) {
                IsSearchContain = IsSearchContain.toUpperCase();
                var inde = this.prodList.filter(function (it) { return it.SearchProduct.startsWith(IsSearchContain) });;
                if (inde.length > 0) {
                    var index = this.prodList.map(item => item.Product_ID).indexOf(inde[0].Product_ID);
                    this.SelectedRowIndex = Number(this.gridApiPrd.getRowNode(index).rowIndex);
                    // if (this.gridApiPrd.getInfiniteRowCount() < this.SelectedRowIndex) {
                    //     this.gridApiPrd.setInfiniteRowCount(this.SelectedRowIndex, false);
                    // }
                    this.gridApiPrd.ensureIndexVisible(this.SelectedRowIndex);
                } else {
                    this.SelectedRowIndex = 0;
                }
            } else {
                // if (this.gridApiPrd.getInfiniteRowCount() < this.SelectedRowIndex) {
                //     this.gridApiPrd.setInfiniteRowCount(this.SelectedRowIndex, false);
                // }
                this.gridApiPrd.ensureIndexVisible(this.SelectedRowIndex);
            }
            if (this.SelectedRowIndex >= TotalRowCount) {
                this.SelectedRowIndex = 0;
            }
            var RowCount = this.gridApiPrd.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiPrd.getModel().getRow(this.SelectedRowIndex).setSelected(true);
            }
        } else {
            this.SelectedRowIndex = 0;
            var RowCount = this.gridApiPrd.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiPrd.getModel().getRow(this.SelectedRowIndex).setSelected(true);
            }
        }
        var RowCount = this.gridApiPrd.getModel().getRowCount();
        if ((event.which == 13 || event.which == 40) && RowCount >= this.SelectedRowIndex && RowCount > 0) {
            this.gridApiPrd.setFocusedCell(this.SelectedRowIndex, "Product_Code");
        }
    }

    close() {
        this.modalService.dismissAll();
    }

    CommonList: any;
    GetProductNotes(ProductId) {
        this.CommonList = [];
        let data = { "Product_ID": ProductId };
        this.http.post('api/Salesinvoices/GET_Product_NOTES', data)
            .subscribe(Response => {
                this.CommonList = Response;
            });
    }

    CommoncolumnDefs: any;
    OpenProductNotesPopup(ProductNotespopup) {
        if (!this.selectedProductInfo.Product_ID) {
            this.toastWarningMsg("Product Not Selected");
            return;
        }
        this.modalReference = this.modalService.open(ProductNotespopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth' });
        this.GetProductNotes(this.selectedProductInfo.Product_ID);
        this.CommoncolumnDefs = [
            { headerName: 'Description', field: 'Notes_Description' },
            { headerName: 'Date', field: 'Notes_Date', width: 100 }
        ]
    }

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg,
            timer: 3000
        });
    }

    gridCommonApi: GridApi;
    gridCommonColumnApi: ColumnApi;
    CommondetailsGridApi(params) {
        this.gridCommonApi = params.api;
        this.gridCommonColumnApi = params.columnApi;
        // setTimeout( () => {
        //     this.gridCommonApi.sizeColumnsToFit();
        // }, 100);
    }

    CopyArrayList(array: any) {
        var arr = [];
        array.forEach(element => {
            var x = Object.assign({}, element);
            arr.push(x);
        });
        return arr;
    }

    filterProducts(event, filterType) {
        $(".button-link").removeClass('active');
        //$('#'+event.target.id).toggleClass('active');
        if (filterType == "Substitute") {
            $('#Substitute').toggleClass('active');
            var Molecule_Desc = this.selectedProductInfo ? this.selectedProductInfo.Molecule_Desc : "";
            var ProductId = this.selectedProductInfo ? this.selectedProductInfo.Product_ID : "";
            this.prodList = this.prodList1.filter(function (item) {
                return item.Molecule_Desc == Molecule_Desc && item.Molecule_Desc != "" && item.Product_ID != ProductId
            });
        } else if (filterType == "NewItems") {
            $('#NewItems').toggleClass('active');
            if (this.SortedProdList.length == 0) {
                this.prodList = this.CopyArrayList(this.prodList1);
                this.SortedProdList = this.prodList.sort((val1, val2) => { return <any>new Date(val2.CreatedOn) - <any>new Date(val1.CreatedOn) })
            }
            this.prodList = [];
            for (var i = 0; i < 20; i++) {
                this.prodList.push(this.SortedProdList[i]);
            }
        } else if (filterType == "Promotional") {
            $('#Promotional').toggleClass('active');
            this.prodList = this.prodList1.filter(function (item) {
                return item.Is_Promotional == 1
            });
        } else {
            $('#AllItems').toggleClass('active');
            this.prodList = this.prodList1;
        }
        this.selectedProductInfo = {};
        this.SetProductDetails(this.selectedProductInfo);
        setTimeout(() => {
            $('#prodfilter-text-box').focus().select();
            this.quickSearch("");
            if (this.gridApiPrd.getModel().getRowCount() > 0) {
                this.SelectedRowIndex = 0;
                this.selectedProductInfo = this.gridApiPrd.getModel().getRow(0).setSelected(true);
                this.gridApiPrd.setFocusedCell(0, "Product_Code");
            }
        }, 100);
    }

    OpenSalesHistoryPopup(SalesHistorypopup) {
        if (!this.selectedProductInfo.Product_ID) {
            this.toastWarningMsg("Product Not Selected");
            return;
        }

        this.modalService.open(SalesHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup' });

        //  $('.ProductPopup input#From_Date').focus().select();
        $('input[name=From_Date]').focus().select();

        this.CommoncolumnDefs = [
            { headerName: 'Code', field: 'Customer_Code', width: 100 },
            { headerName: 'Name', field: 'Customer_Name', width: 180 },
            { headerName: 'Area', field: 'Area_Name', width: 120 },
            { headerName: 'City', field: 'City_Desc', width: 120 },
            { headerName: 'Inv No', field: 'Invoice_No', width: 120 },
            { headerName: 'Inv Date', field: 'Invoice_Date', width: 100 },
            { headerName: 'Batch No', field: 'Batch_No', width: 100 },
            { headerName: 'Exp Date', field: 'Expiry_Date', width: 80 },
            { headerName: 'Qty', field: 'Entry_Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'FQty', field: 'Free_Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'PTR', field: 'PTR', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Rate', field: 'Rate', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Taxable Amt', field: 'Taxable_Amount', width: 100, cellStyle: { 'text-align': 'right' } },
        ]

        this.CommonList = [];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "S", moment(this.orderSearch.From_Date).format('YYYY-MM-DD'), moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
    }

    GetPurchaseOrSalesHistory(ProductId, HistoryType, From_Date, To_Date) {
        var parent = this;
        if (this.orderSearch.To_Date < this.orderSearch.From_Date) {
            this.toastWarningMsg("To Date cannot be less than From Date");
        }
        else {
            if (this.orderSearch.To_Date != null || this.orderSearch.From_Date != null) {
                this.CommonList = [];
                let data = {
                    "Product_ID": ProductId, "Type": HistoryType, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID, "From_Date": From_Date, "To_Date": To_Date
                    // "FYear": this.unitInfo.CurrentFYear
                };
                this.http.post('api/Salesinvoices/Get_Product_History', data)
                    .subscribe(Response => {
                        this.CommonList = Response;
                        var TotalSalesPurchaseHistoryData = { "Vendor_Code": "Total Count :" + this.CommonList.length, "Customer_Code": "Total Count :" + this.CommonList.length, "SR_NO": "Total Count : " + this.CommonList.length, "Batch_No": "Total :", "Entry_Qty": 0, "Free_Qty": 0, "Taxable_Amount": 0, "RCVD": 0, "Issue": 0, "Balance": 0 };

                        TotalSalesPurchaseHistoryData.Entry_Qty = (this.CommonList.reduce(function (acc, sum) {
                            return acc + parent.f_ChkNum(sum.Entry_Qty)
                        }, 0));
                        TotalSalesPurchaseHistoryData.Free_Qty = (this.CommonList.reduce(function (acc, sum) {
                            return acc + parent.f_ChkNum(sum.Free_Qty)
                        }, 0));
                        TotalSalesPurchaseHistoryData.Taxable_Amount = (this.CommonList.reduce(function (acc, sum) {
                            return acc + parent.f_ChkNum(sum.Taxable_Amount)
                        }, 0));
                        TotalSalesPurchaseHistoryData.RCVD = (this.CommonList.reduce(function (acc, sum) {
                            return acc + parent.f_ChkNum(sum.RCVD)
                        }, 0));

                        TotalSalesPurchaseHistoryData.Issue = (this.CommonList.reduce(function (acc, sum) {
                            return acc + parent.f_ChkNum(sum.Issue)
                        }, 0));


                        /* TotalSalesPurchaseHistoryData.Balance = (this.CommonList.reduce(function(acc,sum){
                            return acc + parent.f_ChkNum(sum.Balance)
                        },0)); */

                        TotalSalesPurchaseHistoryData.Balance = (this.f_ChkNum(TotalSalesPurchaseHistoryData.RCVD) - this.f_ChkNum(TotalSalesPurchaseHistoryData.Issue));

                        TotalSalesPurchaseHistoryData.Entry_Qty = this.f_ChkNum(TotalSalesPurchaseHistoryData.Entry_Qty.toFixed(2));
                        TotalSalesPurchaseHistoryData.Free_Qty = this.f_ChkNum(TotalSalesPurchaseHistoryData.Free_Qty.toFixed(2));
                        TotalSalesPurchaseHistoryData.Taxable_Amount = this.f_ChkNum(TotalSalesPurchaseHistoryData.Taxable_Amount.toFixed(2));

                        setTimeout(() => {
                            this.gridCommonApi.setPinnedBottomRowData([TotalSalesPurchaseHistoryData])
                        }, 300);

                        if (HistoryType == 'B') {
                            setTimeout(() => {
                                this.gridCommonApi.sizeColumnsToFit();
                            }, 100);
                        }
                        if (HistoryType == 'M') {
                            this.Barchart.load({
                                json: this.CommonList
                            });
                        }

                        if (!this.CommonList) {
                            $('input[name=From_Date]').focus();
                        }
                    });
            }
        }
    }

    OpenPurchaseHistorypopup(PurchaseHistorypopup) {
        if (!this.selectedProductInfo.Product_ID) {
            this.toastWarningMsg("Product Not Selected");
            return;
        }

        // this.modalReference = this.modalService.open(PurchaseHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup'});
        // this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "P",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));

        this.modalService.open(PurchaseHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup' });

        $('input[name=From_Date]').focus().select();

        this.CommoncolumnDefs = [
            { headerName: 'Code', field: 'Vendor_Code', width: 100 },
            { headerName: 'Name', field: 'Vendor_Name', width: 180 },
            { headerName: 'City', field: 'City_Desc', width: 100 },
            { headerName: 'Inv No', field: 'Doc_No', width: 150 },
            { headerName: 'Inv Dt', field: 'Doc_Date', width: 100 },
            { headerName: 'Batch No', field: 'Batch_No', width: 100 },
            { headerName: 'Exp Dt', field: 'Expiry_Date', width: 80 },
            { headerName: 'Qty', field: 'Entry_Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'FQty', field: 'Free_Qty', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'MRP', field: 'MRP', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'PTR', field: 'PTR', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Rate', field: 'Rate', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Disc', field: 'Discount_Per', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'NPR', field: 'NPR', width: 70, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Taxable Amt', field: 'Taxable_Amount', width: 100, cellStyle: { 'text-align': 'right' } },
        ]
        this.CommonList = [];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "P", moment(this.orderSearch.From_Date).format('YYYY-MM-DD'), moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
    }

    OpenSalesExpHistorypopup(SalesExpHistorypopup) {
        if (!this.selectedProductInfo.Product_ID) {
            this.toastWarningMsg("Product Not Selected");
            return;
        }

        // this.modalReference = this.modalService.open(PurchaseHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup'});
        // this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "P",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));

        this.modalService.open(SalesExpHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup' });

        $('input[name=From_Date]').focus().select();

        this.CommoncolumnDefs = [
            { headerName: 'Sr. No.', field: 'SR_NO', width: 100 },
            { headerName: 'Date', field: 'Invoice_Date', width: 100 },
            { headerName: 'Trans. No', field: 'Invoice_No', width: 150 },
            { headerName: 'Trans. Type', field: 'Transaction_Type', width: 150 },
            { headerName: 'Name', field: 'Customer_Name', width: 180 },
            { headerName: 'Batch No', field: 'Batch_No', width: 100 },
            { headerName: 'RCVD', field: 'RCVD', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Issue', field: 'Issue', width: 100 },
            { headerName: 'Balanace', field: 'Balance', width: 100, cellStyle: { 'text-align': 'right' } },
        ]
        this.CommonList = [];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "X", moment(this.orderSearch.From_Date).format('YYYY-MM-DD'), moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
    }


    OpenMonthWiseSalespopup(MonthWiseSalespopup) {
        if (!this.selectedProductInfo.Product_ID) {
            this.toastWarningMsg("Product Not Selected");
            return;
        }
        this.modalReference = this.modalService.open(MonthWiseSalespopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth' });
        this.genrateBarChart();
        this.CommonList = [];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "M", moment(this.orderSearch.From_Date).format('YYYY-MM-DD'), moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
        // this.CommoncolumnDefs = [
        //     {headerName: 'Month', field: 'Month', width: 200},
        //     {headerName: 'Sales Amount', field: 'Sales_Amount', width: 150, cellStyle: {'text-align': 'right'}}
        // ]
    }

    Barchart: any;
    genrateBarChart() {
        this.Barchart = bb.generate({
            bindto: "#chart",
            data: {
                json: [],
                type: "bar",
                "colors": {
                    "Sales": "#0000FF",
                    "Purchase": "#f0b205"
                },
                keys: {
                    x: "Month",
                    value: ["Sales", "Purchase"],
                }
            },
            axis: {
                x: {
                    type: "category",
                }
            },
            bar: {
                width: {
                    ratio: 1,
                    max: 20
                }
            },
        });
    }


    OpenBatchHoldDetailspopup(BatchHoldDetailspopup) {
        if (!this.selectedProductInfo.Product_ID) {
            this.toastWarningMsg("Product Not Selected");
            return;
        }
        this.modalReference = this.modalService.open(BatchHoldDetailspopup, { size: 'lg', windowClass: 'data-show ProductPopup' });
        this.CommonList = [];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "B", moment(this.orderSearch.From_Date).format('YYYY-MM-DD'), moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
        this.CommoncolumnDefs = [
            { headerName: 'Batch No', field: 'Batch_No', width: 150 },
            { headerName: 'Expiry Date', field: 'Expiry_Date', width: 100 },
            { headerName: 'MFG Date', field: 'MFG_Date', width: 100 },
            { headerName: 'Hold Qty', field: 'Hold_Qty', width: 100, cellStyle: { 'text-align': 'right' } },
            { headerName: 'Bin', field: 'Bin', width: 100 },
            { headerName: 'Warehouse', field: 'Warehouse_Code', width: 150 },
        ]
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }
    From_Datechange(e) {
        if (e.which == 13) {
            $('#To_Date').focus();
        }
    }

    To_Datechange(e) {
        if (e.which == 13) {
            $('#okbtn1').focus();
        }

    }


    onDateSelect(event, id) {
        $(id).focus();
    }

    clearAllFilter() {
        this.searchValue = '';
    }
    public gridApi1: any;
    public gridColumnApi1: any;
    onGridReady1(params) {
        this.gridApi1 = params.api;
        this.gridColumnApi1 = params.columnApi;
        this.gridApi1.sizeColumnsToFit();
    }
    allbatchcolumnDefs: any;
    allbatchrowData: any = [];
    OpenAllBatchpopup(AllBatchpopup) {
        var data = { "Product_ID": this.selectedProductInfo.Product_ID, "Unit_ID": this.unitInfo.Unit_ID, "StockOutwardMethod_Name": this.selectedProductInfo.StockOutwardMethod_Name };
        this.http.post(`/api/${this.unitInfo.Company_Code}/products/GetBatchListByProductID`, data)
            .subscribe(response => {
                this.allbatchcolumnDefs = [
                    { headerName: 'Batch ID', field: 'Batch_ID' },
                    { headerName: 'Batch No', field: 'Batch_No' },
                    { headerName: 'Exp Date', field: 'Expiry_Date' },
                    { headerName: 'MRP', field: 'MRP', cellStyle: { 'textAlign': "right" } },
                    { headerName: 'PTR', field: 'PTR', cellStyle: { 'textAlign': "right" } },
                    { headerName: 'PTS', field: 'PTS', cellStyle: { 'textAlign': "right" } },
                    { headerName: 'Qty', field: 'Qty', cellStyle: { 'textAlign': "right" } },
                    { headerName: 'Scheme', field: 'Scheme' },
                ];
                this.allbatchrowData = response;
                var AllBatchRowData1 = { "Batch_ID": "Total Count : " + this.allbatchrowData.length, "Batch_No": "Total :", "Qty": 0, "Free_Value": 0 }
                AllBatchRowData1.Qty = (this.allbatchrowData.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.Qty)
                }, 0));
                AllBatchRowData1.Free_Value = (this.allbatchrowData.reduce(function (acc, sum) {
                    return acc + parseFloat(sum.Free_Value)
                }, 0)).toFixed(2);


                /*  setTimeout(() => {
                     this.gridApi1.setPinnedBottomRowData([AllBatchRowData1])
                 }, 300);    */
                if (this.allbatchrowData.length > 0) {

                    this.modalReference = this.modalService.open(AllBatchpopup, { size: 'lg', windowClass: 'data-show all-batch-popup' });

                    setTimeout(() => {
                        if (this.allbatchrowData.length > 0) {
                            let allColumnIds = [];
                            this.gridApi1.getModel().getRow(0).setSelected(true);
                            this.gridApi1.setFocusedCell(0, "Batch_No");
                            this.gridColumnApi1.getAllColumns().forEach(function (column) {
                                allColumnIds.push(column.colId);
                            });
                            this.gridColumnApi1.autoSizeColumns(allColumnIds);
                            this.gridApi1.sizeColumnsToFit();
                        }
                    }, 300);
                    // For Date Setting Date Format in MM/YYYY
                    $(document).delegate(".mfgDate, .expDate", "keydown", function (e) {
                        if (
                            $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            return;
                        }

                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) { e.preventDefault(); }

                        if ($(e.target).val().length == 2) { e.target.value = e.target.value + "/"; }
                    });
                    var parent = this;
                    /* $('form[name=allbatch]').on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
                        var self = $(this)
                            , form = self.parents('form:eq(0)')
                            , focusable
                            , next
                            ;
                        if (e.keyCode == 13) {
                            focusable = form.find('input:enabled, a, select, button, textarea, input[role=combobox]').filter(':visible');
                            next = focusable.eq(focusable.index(this) + 1);
                            var res;
                            var attr = $(this).attr('role');
                            if (attr == 'combobox') {
                                res = $(this).parents(".customNgSelect").map(function () {
                                    return this;
                                }).get();
                            }
                            else { res = this; }
                            if (next.length) {
                                if ($(res).hasClass('ng-valid')) { next.focus().select(); }
                                else {
                                    var errorAttr = $(res).attr('data-error');
                                    parent.toastWarningMsg(errorAttr);
                                }
                            } else {
                                $('#savebatch').focus();
                                //form.submit();
                                //parent.addCompany();
                            }
                            return false;
                        }
                    }); */

                }
                else {
                    this.toastWarningMsg("No batch available for: " + this.selectedProductInfo.prodDesc);
                }
            })
    }

    public stockdetailsrowData: any;
    public stockdetailscolumnDefs: any;
    public gridApiStockDetails: any;
    public gridColumnApiStockDetails: any;
    GetOtherBranchData(stockmodalpopup123) {
        let data2 = { "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID, "Product_ID": this.selectedProductInfo.Product_ID };
        this.http.post(`/api/${this.unitInfo.Company_Code}/products/getProductDataForOtherBranch`, data2)
        .subscribe((response : any) => {
            this.stockdetailsrowData = response;
            var self = this;
            this.selectedProduct2.Qty = this.stockdetailsrowData.reduce(function(acc, sum) {
                return acc + self.f_ChkNum(sum.Qty);
            }, 0);
            if (this.stockdetailsrowData.length > 0) {
                this.BranchStockModalPopup(this.stockmodalpopup123);
            } else {
                this.toastWarningMsg('Product not available in other branch');
            }
        })
    }

    BranchStockModalPopup(stockmodalpopup123) {
        this.stockdetailscolumnDefs = [
            { headerName: 'Branch', field: 'Unit_Name', width: 30 },
            { headerName: 'Stock', field: 'Qty', cellStyle: { 'textAlign': "left" }, width: 30 },

        ];
        this.stockmodalpopupRef = this.modalService.open(stockmodalpopup123, { size: 'lg', windowClass: 'data-show updateWarehouseWidth' });
    }

    stockdetailsonGridReady(params) {
        this.gridApiStockDetails = params.api;
        this.gridColumnApiStockDetails = params.columnApi;
        this.gridApiStockDetails.sizeColumnsToFit();
    }

    stockdetailsonSelectionChanged() {
        var selectedRows = this.gridApiStockDetails.getSelectedRows();
    }

    OtherBranchStock(PID){
        this.httpCalling = this.http.get(`/api/${this.unitInfo.Company_Code}/products/OtherBranchStock/${this.unitInfo.Company_ID}/${this.unitInfo.Unit_ID}/${PID}`)
            .subscribe(result => {
                this.TblProductStockBranch = result;
                this.ProductStockBrnch = this.f_ChkNum(this.TblProductStockBranch.reduce(function (acc, sum) {
                    return acc + parseInt(sum.Qty);
                }, 0));
            });
    }

    processPendingQty1(){
        this.CheckExistingPenddingQty1();
       // this.OpenPendingSalesPopUp1(this.f_ChkNum(this.selectedProductInfo.Product_ID));
    }

    pendingsalesqty1:any = 0;
    PendingQtyOtherReason: any = '';
    PendingQtyRemarks: any = '';
    LossQtyRemarksList: any = [
        { key: "Qty not available", value: "Qty not available" },
        { key: "Different batch", value: "Different batch" },
        { key: "Rate difference", value: "Rate difference"},
        { key: "Other", value:"Other"}
    ];
    public pendingsalespopupReference1: NgbModalRef;
    OpenPendingSalesPopUp1(Product_ID) {
        //this.isBusy = false;
        this.pendingsalesqty1 = 0;
        var self = this;

        this.pendingsalespopupReference1 = this.modalService.open(this.pendingsalespopup1, { size: 'lg', windowClass: 'data-show SmallSizePopup' });
        setTimeout(() => {
            $('#pendingsalesqty1').focus().select();
            $(".selectpendingsalesqty1form #sale-loss-product-id").val(Product_ID);
        }, 300);

        $(".selectpendingsalesqty1form").on('keydown', 'input, select, textarea, input[role=combobox]', function (e) {
            var self = $(this), form = self.parents('.selectpendingsalesqty1form:eq(0)'), focusable, next;
            if (e.keyCode == 13) {
                focusable = form.find('input:enabled, a, select, textarea, input[role=combobox]:enabled').filter(':visible');
                next = focusable.eq(focusable.index(this) + 1);
                if (next.length) {
                    next.focus().select();
                } else {
                    $('#btn-sale-pending').focus();
                }
                return false;
            }
        });

        self.pendingsalespopupReference1.result.then(() => {
            console.log("-==-=-1=-=>", this.f_chknum(self.pendingsalesqty1) );
            /* if (self.f_chknum(self.pendingsalesqty1) == 0) {
                self.toastWarningMsg("Quantity should be greater than zero");
                $('#pendingsalesqty1').focus();
                //this.isBusy = false;
                //this.IsDisableSaveBtn = 0;
                $('.template-hidden-values #HiddenProdEnterEventTriggered').val(Product_ID);
                //return false;
            } */
            //this.isBusy = false;
            //this.IsDisableSaveBtn = 0;
            $('.template-hidden-values #HiddenProdEnterEventTriggered').val(0);
        }, () => {
            console.log("-==-=-2=-=>", this.f_chknum(self.pendingsalesqty1) );
            if (this.f_chknum(this.pendingsalesqty1) == 0) {
                $('#pendingsalesqty1').focus();
            }else{
                this.SaveSaleLossQty1(1);
            }
        });
    }

    SaveSaleLossQty1(flag:any = 0) {
        if (this.f_chknum(this.pendingsalesqty1) == 0 && flag == 1) {
            this.toastWarningMsg("Quantity should be greater than zero");
            $('#pendingsalesqty1').focus();
            return false;
        }
        if(this.f_chkString(this.PendingQtyRemarks) == '' && flag == 1){
            setTimeout(() => {
                this.toastWarningMsg("Please enter remarks")
                $('#loss_Remark1 input[role=combobox]').focus();
            }, 500);
            return false;
        }
        if(this.f_chkString(this.PendingQtyRemarks) == 'Other' && this.f_chkString(this.PendingQtyOtherReason) == '' && flag == 1){
            setTimeout(() => {
                this.toastWarningMsg("Please enter reason!");
                $('#PendingQtyOtherReason1').focus();
            }, 500);
            return false;
        }

        var LOSMsg = '';
        var Product_ID = 0;

        Product_ID = this.f_ChkNum(this.selectedProductInfo.Product_ID);
        this.f_SaveSaleLossQty1(Product_ID,LOSMsg,flag);
    }

    f_SaveSaleLossQty1(Product_ID,LOSMsg,flag){
        var LossofSale = {};

        LossofSale = {
            "Customer_ID": this.custId,
            "Customer_Code": this.custcode,
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "Product_ID": Product_ID,
            "Product_Code": this.f_chknum(this.selectedProductInfo.Product_Code),
            "Qty": 0,
            "CreatedBy": this.unitInfo._id,
            "LOSMsg": LOSMsg,
            "OrderQty": 0,
            "TRNType": 'Manual',
            "PendingQty": this.f_chknum(this.pendingsalesqty1),
            "Action": this.f_chkString(this.Action),
            "Invoice_No": this.GetGUID(),
            "PendingQtyRemarks": this.PendingQtyRemarks,
            "PendingQtyRemarksOther": this.PendingQtyRemarks =='Other' ? this.PendingQtyOtherReason: '',
        };
        this.http.post('/api/SalesInvoices/LossOfSalesProdcut', LossofSale)
        .subscribe(result => {
                this.pendingsalespopupReference1.close();
                $('#prodfilter-text-box').focus().select();
                this.pendingsalesqty1 = 0;
                this.PendingQtyRemarks = '';
                this.PendingQtyOtherReason = '';
        });
    }

    
    ExistingPendingQty1:any = 0;
    CheckExistingPenddingQty1(){
        let Product_ID = this.f_ChkNum(this.selectedProductInfo.Product_ID);
        var LossofSale = {
            "Customer_ID": this.custId,
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "Product_ID": Product_ID,
            "CreatedBy": this.unitInfo._id,
        };
        this.httpCalling = this.http.post('/api/SalesInvoices/GetProductPendingQty', LossofSale)
        .subscribe(result => {
            this.ExistingPendingQty1 = this.f_ChkNum(result[0].PendingQty);
            this.OpenPendingSalesPopUp1(this.f_ChkNum(Product_ID));
        });
    }

    Action:any = "ADD";
    PendingQtyProcess1(action){
        if(action == "ADD"){
            //this.pendingsalesqty1 = (this.f_ChkNum(this.pendingsalesqty1) + this.f_ChkNum(this.ExistingPendingQty));
            Swal({
                title: "Add Pending Sales Qty",
                html: `Existing Qty is <b class='text-danger'> ${this.ExistingPendingQty1} </b>, Do you want add  <b class='text-danger'> ${this.pendingsalesqty1} </b> Qty`,
                type: 'warning',
                showCancelButton: true,
                showConfirmButton : true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText:'No',
                customClass: 'swal-warning-custom',
                // focusCancel: true
            }).then(choice => {
                if (choice.value){
                    this.Action = "ADD";
                    this.SaveSaleLossQty1(1);
                }
                /* else{
                    
               } */
                
                
            });
        }

        if(action == "REP"){
            //this.pendingsalesqty1 = this.f_ChkNum(this.pendingsalesqty1);
            Swal({
                title: "Replace Pending Sales Qty",
                html: "Do you want to replace pending sales qty ?",
                type: 'warning',
                showCancelButton: true,
                showConfirmButton : true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText:'No',
                customClass: 'swal-warning-custom',
                focusCancel: true
            }).then(choice => {
                if (choice.value){
                    this.Action = "REP";
                    this.SaveSaleLossQty1(1);
                }
                /* else{
                    
               } */
                
                
            });
        }
    }



    ProductBatchWiseSchemeInfo:any = {};
    BatchwiseschemeQty: any;
    BatchwiseschemeQty1: any;
    BatchwiseschemeQty2: any;
    BatchwiseschemeFreeQty: any;
    BatchwiseschemeFreeQty1: any;
    BatchwiseschemeFreeQty2: any;
    GetProductSchemeInfo(){
        let selectedRowCust = this.gridApiPrd.getSelectedRows();
        this.ProductBatchWiseSchemeInfo.ProductBatchScheme = 0;
        let data = {
            Unit_ID: this.unitInfo.Unit_ID,
            Company_ID: this.unitInfo.Company_ID,
            Product_ID: this.f_chknum(selectedRowCust[0].Product_ID),
            OutwardMethod: selectedRowCust[0].StockOutwardMethod_Name,
            ProductExpiry: selectedRowCust[0].SalesExpiry,
            Sales_Shelf_Life: this.f_chknum(this.unitInfo.Sales_ShelfLife),
            ExpiryDateFormat: selectedRowCust[0].ExpiryDateFormat,
        };
        this.http.post('/api/SalesInvoices/GetBatchDetailByProductIDforProductList', data)
            .subscribe((Res: any) => {
                let ProductBatchScheme = Res[0];
                if(ProductBatchScheme){
                    this.ProductBatchWiseSchemeInfo = Res[0];
                    this.ProductBatchWiseSchemeInfo.ProductBatchScheme = this.f_chkString(this.ProductBatchWiseSchemeInfo.Scheme1) == "" ? "0+0" : this.ProductBatchWiseSchemeInfo.Scheme1;
                    this.ProductBatchWiseSchemeInfo.ProductBatchSchemePer = this.f_chknum(this.ProductBatchWiseSchemeInfo.SchemePer) == 0 ? "0.00" : this.ProductBatchWiseSchemeInfo.SchemePer;
                    this.BatchwiseschemeFreeQty = this.ProductBatchWiseSchemeInfo.SalesSchemeTo;
                    this.BatchwiseschemeFreeQty1 = this.ProductBatchWiseSchemeInfo.SalesSchemeTo1;
                    this.BatchwiseschemeFreeQty2 = this.ProductBatchWiseSchemeInfo.SalesSchemeTo2;
                }
            });
    }
    GetGUID() {
        var chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
        var str_guid = "";
        for (var i = 0; i < 36; i++) {
            var str_guid = str_guid + ((i == 8 || i == 13 || i == 18 || i == 23) ? "-" : chars[Math.floor(Math.random() * chars.length)]);
        };
        str_guid = str_guid.replace(/-/g, '');
        return str_guid;
    }
}
